import { render } from "./QuestionTile.vue?vue&type=template&id=1962180f&scoped=true&ts=true"
import script from "./QuestionTile.vue?vue&type=script&lang=ts"
export * from "./QuestionTile.vue?vue&type=script&lang=ts"

import "./QuestionTile.vue?vue&type=style&index=0&id=1962180f&lang=less"
import "./QuestionTile.vue?vue&type=style&index=1&id=1962180f&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1962180f"]])

export default __exports__